import React, { FC } from 'react';
import FormBlock from 'src/components/FormBlock';
import { OrderMessagesOnExpeditionBoxType } from 'src/types/orderMessagesOnExpeditionBox';
import Detail from './Detail';
import { sizes } from 'src/themes/default';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';

export interface RenderComponentsPropsType {
    formRef: React.RefObject<HTMLFormElement>;
    data: OrderMessagesOnExpeditionBoxType | null;
    onChange: OnChangeType<EditKeysType>;
    editData: OrderMessagesOnExpeditionBoxType;
    editErrors: FormErrorsType;
    disableEdit: boolean;
}

const RenderComponents: FC<RenderComponentsPropsType> = (props) => {
    return (
        <>
            <form ref={props.formRef}>
                <FormBlock sx={{ marginBottom: sizes.blocks_top_MG }}>
                    <Detail
                        onChange={props.onChange}
                        editData={props.editData}
                        editErrors={props.editErrors}
                        disableEdit={props.disableEdit}
                    />
                </FormBlock>
            </form>
        </>
    );
};

export default RenderComponents;
